/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Registered
 *
 * 2 = SentToManager
 *
 * 3 = RepliedToCustomer
 *
 * 4 = Closed
 */
export enum ComplaintStatus {
  Registered = 1,
  SentToManager = 2,
  RepliedToCustomer = 3,
  Closed = 4,
}
